{
  "common": {
    "apply": "Apply",
    "cancel": "Cancel",
    "close": "Close",
    "search": "Search",
    "showMore": "Show more",
    "vs": "vs",
    "ofTotal": "{{percentage}}% of total",
    "showingItems": "Showing {{shown}} of {{total}} items",
    "loadError": "The data could not be loaded. Please try again later."
  },
  "header": {
    "loading": "Loading",
    "refresh": "Refresh",
    "download": "Download",
    "pdf": "PDF",
    "excel": "Excel",
    "share": "Share",
    "shareLink": "Share link"
  },
  "filter": {
    "removeTag": "remove tag",
    "types": {
      "all": "All",
      "location": "Location",
      "installation": "Installation",
      "campaign": "Campaign",
      "playlist": "Playlist",
      "zone": "Zone",
      "gate": "Gate",
      "crossingLine": "Crossing Line"
    },
    "listTitles": {
      "location": "LOCATION",
      "installation": "INSTALLATION",
      "campaign": "CAMPAIGN",
      "playlist": "PLAYLIST",
      "zone": "ZONE",
      "gate": "GATE",
      "crossingLine": "CROSSING LINE"
    },
    "viewMore": {
      "location": "View more locations",
      "installation": "View more installations",
      "campaign": "View more campaigns",
      "playlist": "View more playlists",
      "zone": "View more zones",
      "gate": "View more gates",
      "crossingLine": "View more crossing lines"
    }
  },
  "datePicker": {
    "selectDates": "Select dates",
    "range": "Range",
    "compareTo": "Compare to",
    "month": "Month",
    "year": "Year",
    "previousMonth": "Previous month",
    "nextMonth": "Next month",
    "periodA": "Period A",
    "periodB": "Period B",
    "rangePresets": {
      "today": "Today",
      "yesterday": "Yesterday",
      "1w": "1 week",
      "2w": "2 weeks",
      "1m": "1 month",
      "1y": "1 year",
      "custom": "Custom"
    },
    "comparePresets": {
      "prev-period": "Previous period",
      "prev-month": "Previous month",
      "prev-quarter": "Previous quarter",
      "prev-year": "Previous year",
      "custom": "Custom"
    },
    "strip": {
      "starts": "Starts {{date}}",
      "ends": "Ends {{date}}"
    },
    "footer": {
      "daysEach_one": "{{count}} day each",
      "daysEach_other": "{{count}} days each",
      "bothTo": "{{length}}, both to {{cutoff}}",
      "lessThanAnHour": "less than an hour into today"
    },
    "cellAria": {
      "start": "{{date}}, start of period {{axis}}",
      "end": "{{date}}, end of period {{axis}}",
      "single": "{{date}}, period {{axis}}",
      "within": "{{date}}, within period {{axis}}"
    }
  },
  "compare": {
    "prev-period": "last period",
    "prev-month": "last month",
    "prev-quarter": "last quarter",
    "prev-year": "last year",
    "custom": "last period"
  },
  "cards": {
    "footfall": "Acc. Footfall / OTS",
    "topZones": "Top Zones",
    "crossings": "Crossings",
    "topCrossingLines": "Top Crossing Lines",
    "liveOccupancy": "Live Occupancy",
    "topGates": "Top Gates",
    "peakTime": "Peak-time",
    "peakHour": "Peak Hour",
    "offPeakTime": "Off Peak-time",
    "offPeakHour": "Off Peak Hour",
    "totalPeople": "Total People",
    "traffic": "Traffic",
    "watchers": "Watchers",
    "dwellTime": "Dwell time",
    "avgAttentionTime": "Avg. attention time",
    "gender": "Gender",
    "age": "Age",
    "emotion": "Emotion",
    "interactionCoreMetrics": "Interactions core metrics",
    "interactions": "Interactions",
    "interactionsLower": "interactions",
    "rest": "Rest",
    "avgTime": "Avg. time",
    "topInteractedProduct": "Top interacted product",
    "top5Products": "Top 5 product",
    "historical": "Historical"
  },
  "gender": {
    "Male": "Male",
    "Female": "Female",
    "Unknown": "Unknown"
  },
  "age": {
    "Children (0-20)": "Children (0-20)",
    "Young (21-40)": "Young (21-40)",
    "Middle Age (41-60)": "Middle (41-60)",
    "Elder (61-99)": "Elder (60)",
    "Unknown": "Unknown"
  },
  "emotion": {
    "calm": "Calm",
    "happy": "Happy",
    "surprise": "Surprise",
    "anger": "Anger",
    "sad": "Sad"
  },
  "mediaPlayback": {
    "title": "Media Playback",
    "searchPlaceholder": "Search Media",
    "views": "Views",
    "partially": "Partially",
    "fully": "Fully",
    "totalViewsIn": "total views in",
    "columns": {
      "media": "MEDIA",
      "campaign": "CAMPAIGN",
      "playlist": "PLAYLIST",
      "played": "PLAYED",
      "views": "VIEWS",
      "partially": "PARTIALLY",
      "fully": "FULLY"
    }
  },
  "productSales": {
    "title": "Sales & Earnings",
    "family": "Family",
    "product": "Product",
    "brand": "Brand",
    "earnings": "Earnings",
    "units": "Units",
    "columns": {
      "name": "NAME",
      "code": "CODE",
      "media": "MEDIA",
      "totalPlays": "TOTAL PLAYS",
      "units": "UNITS",
      "totalSales": "TOTAL SALES"
    }
  },
  "historical": {
    "timeLapse": {
      "Hours": "Hours",
      "Days": "Days",
      "Months": "Months",
      "Years": "Years"
    },
    "analyticTypes": {
      "traffic": "traffic",
      "views": "watchers",
      "dwell": "dwell",
      "attention": "attention",
      "age": "age",
      "gender": "gender",
      "sales": "sales",
      "gate": "gate",
      "zone": "zone",
      "crossingLine": "crossing line"
    }
  },
  "dates": {
    "months": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    "weekdays": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
    "weekdaysShort": ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"]
  },
  "pdf": {
    "account": "Account",
    "location": "Location",
    "installation": "Installation",
    "campaign": "Campaign",
    "period": "Period"
  },
  "excel": {
    "sheets": {
      "byHour": "ByHour",
      "byWeekday": "ByWeekday",
      "byMonth": "ByMonth",
      "byYear": "ByYear",
      "mediaPlayback": "Media Playback"
    },
    "audienceHeader": ["Account", "Location", "Installation", "Campaign", "From", "To", "When", "Traffic", "Watchers", "Dwell", "Attention", "Children", "Young", "Middle Age", "Elder", "Female", "Male", "Total Traffic", "Total Watchers", "Total Dwell", "Total Attention", "Total Children", "Total Young", "Total Middle Age", "Total Elder", "Total Female", "Total Male"],
    "mediaPlaybackHeader": ["Media", "Campaign", "Playlist", "Played", "Views", "Partially", "Fully"]
  },
  "information": {
    "traffic": {
      "name": "Traffic",
      "tooltip": "People detected within the defined area of interest, if one has been configured.",
      "moreInformation": "Counts people detected within the area of interest defined for this installation.\nIf no area has been configured, it counts all people detected in the camera range.\nIt does not indicate whether they saw any content — those who looked at the screen are counted as Watchers."
    },
    "avgAttentionTime": {
      "name": "Avg. attention time",
      "tooltip": "Average time a Watcher actively looked at the screen.",
      "moreInformation": "Shows how long people looked at the screen, on average.\n\nExample:\n\nWatcher 1: looks for 4 seconds\nWatcher 2: looks for 6 seconds\nAvg. attention time: 5 seconds\n\nA look is counted when a person's gaze is directed at the screen for at least 0.5 seconds."
    },
    "watchers": {
      "name": "Watchers",
      "tooltip": "Number of people who looked at the screen.",
      "moreInformation": "Counts the people who paid attention to the screen.\nIt shows how many people actually saw the content.\nIt does not include people who simply walked past without looking."
    },
    "dwellTime": {
      "name": "Dwell time",
      "tooltip": "Average time a person spends within the area of interest, if one has been configured.",
      "moreInformation": "Shows how long people stay in the area of interest on average, regardless of whether they looked at the screen.\nFor example, if three people stay for 10, 20 and 30 seconds, the Dwell time is 20 seconds."
    },
    "gender": {
      "name": "Gender",
      "tooltip": "Percentage of detected men and women.",
      "moreInformation": "Shows how the audience is divided between men and women."
    },
    "age": {
      "name": "Age",
      "tooltip": "Percentage of people detected in each age group.",
      "moreInformation": "Shows how the audience is distributed across age groups.\nFor example: under 20, between 21 and 40, or over 60."
    },
    "emotion": {
      "name": "Emotion",
      "tooltip": "Facial expressions detected on people's faces.",
      "moreInformation": "Shows whether an expression appears happy, sad, surprised, angry or neutral.\nIt is an estimate of the visible expression, not of how the person actually feels."
    },
    "mediaPlayback": {
      "name": "Media Playback",
      "tooltip": "Results for each advertisement or piece of content shown on the screen.",
      "moreInformation": "Shows how many times each piece of content was viewed and how many people saw it.\nSeparates partially viewed content from fully viewed content.\nIt also shows the equivalent cost on Meta and the type of audience that viewed it.\nThe table allows users to compare results by media file, campaign and playlist."
    },
    "views": {
      "name": "Views",
      "tooltip": "Total number of times people looked at the screen.",
      "moreInformation": "Each time someone looks at the screen, one View is counted.\nThe same person can generate several Views.\nExample: if one person looks at the screen three times, this counts as 1 Watcher and 3 Views.\n\nA look is counted when a person's gaze is directed at the screen for at least 0.5 seconds."
    },
    "played": {
      "name": "Ad Plays",
      "tooltip": "Number of times this content was played on the screen.",
      "moreInformation": "Counts how many times the ad, video or image was played on the screen."
    },
    "mediaViews": {
      "name": "Views",
      "tooltip": "Total number of times people looked at this content.",
      "moreInformation": "Counts how many times people looked at the content.\nOne playback can generate several Views, because several people may watch it, and the same person may also look more than once.\nExample: if the content is played 10 times and generates 25 looks, then Ad Plays = 10 and Views = 25.\n\nA look is counted when a person's gaze is directed at the screen for at least 0.5 seconds."
    },
    "partially": {
      "name": "Partially",
      "tooltip": "Number of times someone watched at least 30% of the advertisement.",
      "moreInformation": "Counts views where the person watched at least 30% but less than 70% of the content.\nExample: someone watches 8 seconds of a 20-second advertisement (40%)."
    },
    "fully": {
      "name": "Fully",
      "tooltip": "Number of times someone watched at least 70% of the advertisement.",
      "moreInformation": "Counts views where the person watched 70% or more of the content.\nExample: someone watches 16 seconds of a 20-second advertisement (80%)."
    },
    "cpmEquivalent": {
      "name": "CPM equivalent",
      "tooltip": "Estimated cost of achieving the same number of Views through Meta ads.",
      "moreInformation": "Compares the Views recorded by Broox with Meta's average cost per 1,000 impressions.\nThe same person can generate several Views."
    },
    "cpuEquivalent": {
      "name": "CPU equivalent",
      "tooltip": "Estimated cost of reaching the same number of unique people through Meta.",
      "moreInformation": "Compares Broox Watchers with the cost of reaching unique people on Meta.\nEach person is counted only once, even if they look several times."
    },
    "mostViewedProduct": {
      "name": "Most viewed product",
      "tooltip": "Product that received the highest number of Views.",
      "moreInformation": "Shows which product generated the most Views.\nIn this example, Men's T-shirt received 1,282 Views.\nThis represents approximately 36% of the 3,551 total Views."
    },
    "media": {
      "name": "Media",
      "tooltip": "The specific file shown on the screen.",
      "moreInformation": "It is the advertisement, video or image that was played.\nIt allows users to view the results of each piece of content separately."
    },
    "campaign": {
      "name": "Campaign",
      "tooltip": "The campaign that the content belongs to.",
      "moreInformation": "Groups several advertisements or pieces of content under the same campaign.\nIt allows users to compare the overall campaign results and the results of each individual item."
    },
    "playlist": {
      "name": "Playlist",
      "tooltip": "A list of content played together in a specific order.",
      "moreInformation": "Groups the videos or images shown on the screen.\nIt shows which playlist each piece of content was included in."
    },
    "interactionCoreMetrics": {
      "name": "Interaction core metrics",
      "tooltip": "Summary of the main product interaction metrics.",
      "moreInformation": "Shows how many times people interacted with products and the average duration of each interaction.\nIt helps users understand how much interest the products generate."
    },
    "interactions": {
      "name": "Interactions",
      "tooltip": "Total number of times people interacted with a product.",
      "moreInformation": "Counts each time someone picks up, touches or moves a product.\nThe same person can generate several interactions.\nExample: if someone picks up two products, this counts as 2 interactions."
    },
    "avgTime": {
      "name": "Avg. time",
      "tooltip": "Average duration of each interaction.",
      "moreInformation": "Shows how long people interact with a product, on average.\nExample: if interactions last 2, 4 and 6 seconds, the average time is 4 seconds."
    },
    "topInteractedProduct": {
      "name": "Top interacted product",
      "tooltip": "Product with the most interactions.",
      "moreInformation": "Shows which product was touched, picked up or moved the most times."
    },
    "top5Products": {
      "name": "Top 5 products",
      "tooltip": "The five products with the most interactions.",
      "moreInformation": "Shows the products that were touched, picked up or moved the most times.\nThe number shows how many interactions each product received.\nThe arrow shows whether it received more or fewer interactions than in the previous period."
    },
    "historical": {
      "name": "Historical",
      "tooltip": "How the metrics change over time.",
      "moreInformation": "Shows how the data changes during the selected period.\nUsers can compare metrics such as Traffic and Attention time by hour, day or week.\nIt helps identify the times with the most people or the highest attention."
    },
    "salesAndEarnings": {
      "name": "Sales & Earnings",
      "tooltip": "Summary of sales and revenue.",
      "moreInformation": "Shows how much money was generated and how many units were sold.\nIt provides a quick overview of the commercial results for the selected period."
    },
    "earnings": {
      "name": "Earnings",
      "tooltip": "Total money generated from sales.",
      "moreInformation": "Shows the total amount generated during the selected period.\nThe arrow indicates whether it increased or decreased compared with the previous period."
    },
    "units": {
      "name": "Units",
      "tooltip": "Total number of products sold.",
      "moreInformation": "Counts how many units were sold during the selected period.\nThe arrow shows the difference compared with the previous period."
    },
    "footfall": {
      "name": "Footfall",
      "tooltip": "People who passed through an area, without any connection to a specific screen.",
      "moreInformation": "Counts the movement or presence of people in a space, regardless of whether they had the opportunity to see any content.\nIt is the basic circulation metric.\nIt does not indicate any type of advertising exposure."
    },
    "topZones": {
      "name": "Top Zones",
      "tooltip": "Areas with the highest number of people.",
      "moreInformation": "Shows how Footfall is distributed across the different areas of the space.\nThe percentage shows how much of the total movement happened in each area.\nIt does not mean those people saw a screen or advertisement; it only means they were present in or passed through that area."
    },
    "peakTime": {
      "name": "Peak time",
      "tooltip": "Time of day with the highest number of people in the space.",
      "moreInformation": "Shows when the highest Footfall was recorded.\nIt helps identify the busiest times."
    },
    "peakHour": {
      "name": "Peak Hour",
      "tooltip": "Time when the highest number of people was recorded.",
      "moreInformation": ""
    },
    "totalPeople": {
      "name": "Total People",
      "tooltip": "Number of people recorded during the busiest moment.",
      "moreInformation": ""
    },
    "offPeakTime": {
      "name": "Off-Peak time",
      "tooltip": "Time of day with the lowest number of people in the space.",
      "moreInformation": "Shows when the lowest Footfall was recorded.\nIt helps identify the quietest times."
    },
    "offPeakHour": {
      "name": "Off-Peak Hour",
      "tooltip": "Time when the lowest number of people was recorded.",
      "moreInformation": ""
    },
    "fewPeople": {
      "name": "Few People",
      "tooltip": "Number of people recorded at that moment.",
      "moreInformation": ""
    },
    "liveOccupancy": {
      "name": "Live occupancy",
      "tooltip": "Number of people currently present in the space.",
      "moreInformation": "Shows how many people are in the space right now.\nIt updates in real time as people enter or leave.\nThe chart shows how occupancy has changed during the last few hours.\n\nExample: if it shows 760, it means approximately 760 people are currently inside the space."
    },
    "topGates": {
      "name": "Top Gates",
      "tooltip": "Entrances or access points used by the highest number of people.",
      "moreInformation": "Shows how Footfall is distributed across the different entrances.\nThe percentage indicates how much of the total passed through each entrance."
    },
    "entries": {
      "name": "Entries",
      "tooltip": "Number of people who entered through each area or access point.",
      "moreInformation": "Compares the number of entries recorded at different locations.\nThe data can be grouped by area or entrance gate.\nLonger bars indicate the places where more people entered.\nIt helps identify which entrances have the highest traffic."
    }
  }
}
